import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#2C3C30] px-6"
      data-testid="admin-login-page"
    >
      <div className="w-full max-w-md bg-[#F7F6F2] rounded-3xl p-10 md:p-12">
        <div className="flex items-center justify-center w-14 h-14 rounded-full bg-[#2C3C30] mb-6">
          <Lock size={24} className="text-[#F7F6F2]" />
        </div>
        <h1 className="font-serif text-4xl text-[#2C3C30] tracking-tight">
          Admin Access
        </h1>
        <p className="font-sans text-[#566158] mt-2 mb-8">
          Sign in to manage bookings and reviews.
        </p>
        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-6">
          <div>
            <label className="font-sans text-xs uppercase tracking-[0.2em] text-[#566158]">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email"
              className="w-full bg-transparent border-b border-[#2C3C30]/25 focus:border-[#2C3C30] outline-none py-3 font-sans text-lg text-[#1A211D] transition-colors"
              placeholder="you@adyanutrition.com"
            />
          </div>
          <div>
            <label className="font-sans text-xs uppercase tracking-[0.2em] text-[#566158]">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password"
              className="w-full bg-transparent border-b border-[#2C3C30]/25 focus:border-[#2C3C30] outline-none py-3 font-sans text-lg text-[#1A211D] transition-colors"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="font-sans text-sm text-[#a13a2f]">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#2C3C30] px-8 py-4 text-[#F7F6F2] font-medium transition-colors duration-300 hover:bg-[#1A211D] disabled:opacity-60"
          >
            {loading ? <><Loader2 size={18} className="animate-spin" /> Signing in...</> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
